import { lazy, ComponentType } from 'react';

type LazyFactory = () => Promise<{ default: ComponentType<any> }>;

const CHUNK_RELOAD_KEY = 'ez_chunk_reload';

const isChunkLoadError = (error: unknown): boolean =>
  error instanceof Error &&
  (error.name === 'ChunkLoadError' || /Loading chunk .* failed/i.test(error.message));

export function lazyWithRetry(factory: LazyFactory) {
  return lazy(async () => {
    try {
      const module = await factory();
      sessionStorage.removeItem(CHUNK_RELOAD_KEY);
      return module;
    } catch (error) {
      if (isChunkLoadError(error) && !sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
        sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
        window.location.reload();
        return new Promise<{ default: ComponentType<any> }>(() => {});
      }
      throw error;
    }
  });
}
